import type { useForm } from 'vee-validate'

/**
 * Erstellt ein debounctes Field für vee-validate 4
 * @param fieldName Der Pfad zum Feld (z.B. 'contactInformation.phone')
 * @param defineField Die defineField-Funktion aus useForm
 * @param validateField Die validateField-Funktion aus useForm
 * @param wait Millisekunden für das Debounce (default 300)
 */
export function useDebouncedField(fieldName: string, defineField: ReturnType<typeof useForm>['defineField'], validateField: ReturnType<typeof useForm>['validateField'], wait = 300) {
	// 1. Feld ganz normal definieren
	// Wir schalten die Automatik ab, damit unser manuelles Debounce die Kontrolle hat
	const [value, attrs] = defineField(fieldName, {
		validateOnModelUpdate: false,
		validateOnInput: true,
		validateOnChange: true,
		validateOnBlur: true,
	})

	// 2. Die Validierung für dieses spezifische Feld debouncen
	const debouncedValidate = useDebounceFn(() => {
		validateField(fieldName)
	}, wait)

	// 3. Wir bauen das attrs-Objekt um und injizieren unser debounctes onInput
	const debouncedAttrs = ref({
		...attrs.value,
		onInput: (e: Event | string) => {
			// Erst den Wert im State aktualisieren (damit validateField den neuen Wert sieht)
			const target = (e as Event)?.target as HTMLInputElement | null
			value.value = target?.value !== undefined ? target.value : e
			// Dann die verzögerte Validierung triggern
			debouncedValidate()
		},
	})

	return [value, debouncedAttrs] as const
}
